import BootstrapVueNext from 'bootstrap-vue-next';

export default (Vue) => {
  Vue.use(BootstrapVueNext);
};
